/**
 * Natural document-top offset of an element, summed up the offsetParent chain — the scroll position
 * that lands it at the top of the viewport.
 *
 * Prefer this over `getBoundingClientRect().top + window.scrollY` for anything `position: sticky`.
 * A pinned sticky element reports its *pinned* viewport offset from getBoundingClientRect, so the
 * rect-based sum reads as `stickyTop + scrollY` — which grows with the scroll position instead of
 * describing where the element actually lives in the document. `offsetTop` is unaffected by sticky
 * pinning, so this stays correct at any scroll offset.
 */
export const absoluteOffsetTop = (element: HTMLElement): number => {
  let top = 0;
  let node: HTMLElement | null = element;
  while (node) {
    top += node.offsetTop;
    node = node.offsetParent as HTMLElement | null;
  }
  return top;
};
